import React, { useState } from 'react';
import {
  ArrowLeft,
  Search,
  ChevronDown,
  Calendar,
  Filter,
  Download,
  Printer,
  X,
  FileSpreadsheet,
  FileText,
  User,
  Phone,
  Mail,
  Home,
} from 'lucide-react';
import { ResidentSubMenuKey } from '../ResidentDirectory';

interface Props {
  onBack: () => void;
  onNavigate?: (tab: ResidentSubMenuKey) => void;
}

export interface ResidentHistoryRecord {
  id: string;
  isLatest?: boolean;
  type: 'ผู้อยู่อาศัย' | 'เจ้าของ' | 'ผู้เช่า' | 'ตัวแทน';
  status: 'ออกแล้ว' | 'อยู่อาศัย';
  moveInDate: string; // e.g. "04/08/2022"
  moveOutDate: string; // e.g. "21/03/2024"
  roomNumber: string; // e.g. "1086/8969"
  fullName: string;
  reasonForLeaving: string; // e.g. "หมดสัญญารายเดือน / ปี"
  phone: string;
  email: string;
  nationality: string; // e.g. "TH", "EC"
}

// Exactly matching image 4 (image (10).png)
const INITIAL_HISTORY_RECORDS: ResidentHistoryRecord[] = [
  {
    id: 'rh-1',
    isLatest: false,
    type: 'ผู้อยู่อาศัย',
    status: 'ออกแล้ว',
    moveInDate: '04/08/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'อลิซ ปาร์ค',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0657984511',
    email: 'alicepark@gmail.com',
    nationality: 'TH',
  },
  {
    id: 'rh-2',
    isLatest: false,
    type: 'เจ้าของ',
    status: 'ออกแล้ว',
    moveInDate: '09/08/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'jay park',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0852369369',
    email: 'jaypark@gmail.com',
    nationality: 'TH',
  },
  {
    id: 'rh-3',
    isLatest: false,
    type: 'ผู้อยู่อาศัย',
    status: 'ออกแล้ว',
    moveInDate: '16/08/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'waii kamikaze',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0659789625',
    email: 'bmretainer@gmail.com',
    nationality: 'TH',
  },
  {
    id: 'rh-4',
    isLatest: false,
    type: 'เจ้าของ',
    status: 'ออกแล้ว',
    moveInDate: '02/09/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'soyou sistar',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0655525252',
    email: 'bmretainer@gmail.com',
    nationality: 'TH',
  },
  {
    id: 'rh-5',
    isLatest: false,
    type: 'ผู้เช่า',
    status: 'ออกแล้ว',
    moveInDate: '21/09/2023',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'ราน ราน',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '-',
    email: 'supawadee@silverman.app',
    nationality: 'TH',
  },
  {
    id: 'rh-6',
    isLatest: false,
    type: 'ผู้อยู่อาศัย',
    status: 'ออกแล้ว',
    moveInDate: '21/09/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'hsb ahh',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '08152436794',
    email: 'asdfghk@gmail.com',
    nationality: 'TH',
  },
  {
    id: 'rh-7',
    isLatest: false,
    type: 'เจ้าของ',
    status: 'ออกแล้ว',
    moveInDate: '25/04/2023',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'tiffany _',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0659879625',
    email: 'wwe@co.th',
    nationality: 'TH',
  },
  {
    id: 'rh-8',
    isLatest: false,
    type: 'ตัวแทน',
    status: 'ออกแล้ว',
    moveInDate: '21/09/2023',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'สายัน สายัน',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '-',
    email: 'supawadee@silverman.app',
    nationality: 'TH',
  },
  {
    id: 'rh-9',
    isLatest: true,
    type: 'ผู้อยู่อาศัย',
    status: 'ออกแล้ว',
    moveInDate: '09/11/2023',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/8969',
    fullName: 'อาร์ อาร์',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0874589068',
    email: 'supawadee@silverman.app',
    nationality: 'TH',
  },
  {
    id: 'rh-10',
    isLatest: false,
    type: 'ผู้อยู่อาศัย',
    status: 'ออกแล้ว',
    moveInDate: '14/11/2022',
    moveOutDate: '21/03/2024',
    roomNumber: '1086/1111',
    fullName: 'pang pangg',
    reasonForLeaving: 'หมดสัญญารายเดือน / ปี',
    phone: '0961874010',
    email: 'wasabipang@gmail.com',
    nationality: 'EC',
  },
];

export const ResidentHistoryLogsView: React.FC<Props> = ({ onBack, onNavigate }) => {
  const [records, setRecords] = useState<ResidentHistoryRecord[]>(INITIAL_HISTORY_RECORDS);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [typeFilter, setTypeFilter] = useState('ทั้งหมด');
  const [searchQuery, setSearchQuery] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState('10');
  const [selectedRecord, setSelectedRecord] = useState<ResidentHistoryRecord | null>(null);

  const tabs: { key: ResidentSubMenuKey; label: string }[] = [
    { key: 'members', label: 'เจ้าของร่วม/สมาชิก' },
    { key: 'vehicles', label: 'ยานพาหนะ' },
    { key: 'keycards', label: 'คีย์การ์ด' },
    { key: 'foreign_ownership', label: 'กรรมสิทธิ์ชาวต่างชาติ' },
    { key: 'pets', label: 'สัตว์เลี้ยง' },
    { key: 'title_deeds', label: 'กรรมสิทธิ์' },
    { key: 'history_logs', label: 'ประวัติผู้อยู่อาศัย' },
  ];

  // Filter records
  const filteredRecords = records.filter((rec) => {
    const q = searchQuery.toLowerCase().trim();
    const matchSearch =
      !q ||
      rec.roomNumber.toLowerCase().includes(q) ||
      rec.fullName.toLowerCase().includes(q) ||
      rec.phone.toLowerCase().includes(q) ||
      rec.email.toLowerCase().includes(q) ||
      rec.reasonForLeaving.toLowerCase().includes(q) ||
      rec.nationality.toLowerCase().includes(q);

    const matchType = typeFilter === 'ทั้งหมด' || rec.type === typeFilter;

    // Date range filter if provided
    let matchDate = true;
    if (startDate) {
      // Compare simple formats if needed
      matchDate = matchDate && rec.moveInDate >= startDate;
    }
    if (endDate) {
      matchDate = matchDate && rec.moveOutDate <= endDate;
    }

    return matchSearch && matchType;
  });

  const getTypeBadge = (type: ResidentHistoryRecord['type']) => {
    switch (type) {
      case 'ผู้เช่า':
        return (
          <span className="inline-block px-2.5 py-0.5 rounded text-[11px] font-medium bg-slate-700 text-white">
            ผู้เช่า
          </span>
        );
      case 'ตัวแทน':
        return (
          <span className="inline-block px-2.5 py-0.5 rounded text-[11px] font-medium bg-amber-100 text-amber-900 border border-amber-300">
            ตัวแทน
          </span>
        );
      case 'เจ้าของ':
        return (
          <span className="inline-block px-2.5 py-0.5 rounded text-[11px] font-medium bg-slate-100 text-slate-700 border border-slate-200">
            เจ้าของ
          </span>
        );
      case 'ผู้อยู่อาศัย':
      default:
        return (
          <span className="inline-block px-2.5 py-0.5 rounded text-[11px] font-medium bg-slate-100 text-slate-700 border border-slate-200">
            ผู้อยู่อาศัย
          </span>
        );
    }
  };

  return (
    <div className="font-prompt bg-white min-h-[85vh] rounded-2xl shadow-xs border border-slate-200/80 overflow-hidden">
      {/* 1. Top Sub-Navigation Tabs */}
      <div className="border-b border-slate-200 bg-slate-50/50 px-4 sm:px-6 pt-3 overflow-x-auto">
        <div className="flex items-center gap-6 sm:gap-8 min-w-max text-xs sm:text-sm">
          {tabs.map((tab) => {
            const isActive = tab.key === 'history_logs';
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => {
                  if (tab.key === 'history_logs') return;
                  if (onNavigate) {
                    onNavigate(tab.key);
                  } else {
                    onBack();
                  }
                }}
                className={`pb-3 font-medium transition-colors cursor-pointer relative ${
                  isActive
                    ? 'text-slate-900 font-bold border-b-2 border-teal-600'
                    : 'text-slate-500 hover:text-slate-800'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="p-4 sm:p-6 space-y-5">
        {/* 2. Top Header & Filters Bar matching image 4 */}
        <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4">
          {/* Title with Back Button */}
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onBack}
              className="w-7 h-7 rounded-full border border-slate-300 hover:border-slate-400 bg-white flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors cursor-pointer"
              title="ย้อนกลับ"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <h1 className="text-lg sm:text-xl font-bold text-slate-800 tracking-tight">
              ประวัติผู้อยู่อาศัย
            </h1>
          </div>

          {/* Filters on Right: Date Range, Type Dropdown, Search Input */}
          <div className="flex flex-wrap items-center gap-2.5 sm:gap-3 text-xs text-slate-600">
            {/* Start Date */}
            <div className="flex items-center gap-1.5">
              <span className="text-slate-600 font-medium">วันที่:</span>
              <div className="relative">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="mm/dd/yyyy"
                  className="pl-2.5 pr-2 py-1.5 bg-white border border-slate-300 rounded-md text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-500 w-34"
                />
              </div>
            </div>

            {/* End Date */}
            <div className="flex items-center gap-1.5">
              <span className="text-slate-600 font-medium">ถึง:</span>
              <div className="relative">
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  placeholder="mm/dd/yyyy"
                  className="pl-2.5 pr-2 py-1.5 bg-white border border-slate-300 rounded-md text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-500 w-34"
                />
              </div>
            </div>

            {/* Type Filter Dropdown */}
            <div className="relative">
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className="appearance-none pl-3 pr-7 py-1.5 bg-white border border-slate-300 rounded-md text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-500 cursor-pointer min-w-[90px]"
              >
                <option value="ทั้งหมด">ทั้งหมด</option>
                <option value="ผู้อยู่อาศัย">ผู้อยู่อาศัย</option>
                <option value="เจ้าของ">เจ้าของ</option>
                <option value="ผู้เช่า">ผู้เช่า</option>
                <option value="ตัวแทน">ตัวแทน</option>
              </select>
              <ChevronDown className="w-3.5 h-3.5 text-slate-400 absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
            </div>

            {/* Search Input */}
            <div className="relative flex-1 sm:flex-initial">
              <input
                type="text"
                placeholder="ค้นหา"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-3 pr-8 py-1.5 bg-white border border-slate-300 rounded-md text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-500 w-full sm:w-48 placeholder-slate-400"
              />
              <Search className="w-3.5 h-3.5 text-slate-400 absolute right-2.5 top-1/2 -translate-y-1/2" />
            </div>
          </div>
        </div>

        {/* 3. Table matching image 4 */}
        <div className="border border-slate-200 rounded-xl overflow-hidden shadow-2xs">
          <div className="overflow-x-auto">
            <table className="w-full text-xs text-left border-collapse">
              <thead>
                <tr className="bg-slate-100/90 text-slate-700 font-medium border-b border-slate-200 text-center">
                  <th className="py-2.5 px-3 w-10 text-slate-400">
                    <span className="inline-block text-[10px]">▼</span>
                  </th>
                  <th className="py-2.5 px-3 whitespace-nowrap">ประเภท</th>
                  <th className="py-2.5 px-3 whitespace-nowrap">สถานะ</th>
                  <th className="py-2.5 px-3 whitespace-nowrap">วันที่เข้า</th>
                  <th className="py-2.5 px-3 whitespace-nowrap">วันที่ออก</th>
                  <th className="py-2.5 px-3 whitespace-nowrap">ห้อง</th>
                  <th className="py-2.5 px-4 whitespace-nowrap text-left">ชื่อ-นามสกุล</th>
                  <th className="py-2.5 px-4 whitespace-nowrap text-left">สาเหตุที่ออก</th>
                  <th className="py-2.5 px-3 whitespace-nowrap text-left">เบอร์โทร</th>
                  <th className="py-2.5 px-4 whitespace-nowrap text-left">E-mail</th>
                  <th className="py-2.5 px-3 whitespace-nowrap">สัญชาติ</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 text-slate-700">
                {filteredRecords.map((item, idx) => (
                  <tr
                    key={item.id}
                    className="hover:bg-slate-50/80 transition-colors text-center"
                  >
                    {/* Leftmost column for Latest badge or indicator */}
                    <td className="py-3 px-2">
                      {item.isLatest && (
                        <span className="inline-block px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-rose-500 text-white leading-none shadow-2xs">
                          ล่าสุด
                        </span>
                      )}
                    </td>

                    {/* ประเภท */}
                    <td className="py-3 px-3 whitespace-nowrap">
                      {getTypeBadge(item.type)}
                    </td>

                    {/* สถานะ */}
                    <td className="py-3 px-3 whitespace-nowrap">
                      <span className="inline-block px-2.5 py-0.5 rounded-full text-[11px] font-medium bg-rose-500 text-white shadow-2xs">
                        {item.status}
                      </span>
                    </td>

                    {/* วันที่เข้า */}
                    <td className="py-3 px-3 whitespace-nowrap text-slate-600">
                      {item.moveInDate}
                    </td>

                    {/* วันที่ออก */}
                    <td className="py-3 px-3 whitespace-nowrap text-slate-600">
                      {item.moveOutDate}
                    </td>

                    {/* ห้อง */}
                    <td className="py-3 px-3 whitespace-nowrap font-medium text-slate-800">
                      {item.roomNumber}
                    </td>

                    {/* ชื่อ-นามสกุล */}
                    <td className="py-3 px-4 whitespace-nowrap text-left font-medium">
                      <button
                        type="button"
                        onClick={() => setSelectedRecord(item)}
                        className="text-sky-600 hover:text-sky-800 hover:underline cursor-pointer transition-colors text-left"
                      >
                        {item.fullName}
                      </button>
                    </td>

                    {/* สาเหตุที่ออก */}
                    <td className="py-3 px-4 whitespace-nowrap text-left text-slate-600">
                      {item.reasonForLeaving}
                    </td>

                    {/* เบอร์โทร */}
                    <td className="py-3 px-3 whitespace-nowrap text-left text-slate-600 font-mono">
                      {item.phone}
                    </td>

                    {/* E-mail */}
                    <td className="py-3 px-4 whitespace-nowrap text-left text-slate-600">
                      {item.email}
                    </td>

                    {/* สัญชาติ */}
                    <td className="py-3 px-3 whitespace-nowrap text-slate-700 font-semibold">
                      {item.nationality}
                    </td>
                  </tr>
                ))}

                {filteredRecords.length === 0 && (
                  <tr>
                    <td colSpan={11} className="py-8 text-center text-slate-400">
                      ไม่พบข้อมูลประวัติผู้อยู่อาศัยที่ตรงกับเงื่อนไข
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 4. Table Footer & Pagination matching image */}
          <div className="bg-white px-4 py-3 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
            <div className="flex items-center gap-2">
              <span>แสดง</span>
              <div className="relative">
                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(e.target.value)}
                  className="appearance-none pl-2.5 pr-6 py-1 bg-white border border-slate-300 rounded text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-sky-500 cursor-pointer"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <ChevronDown className="w-3 h-3 text-slate-400 absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none" />
              </div>
              <span>รายการ/หน้า</span>
            </div>

            <div className="text-slate-600">
              รายการทั้งหมด {filteredRecords.length}
            </div>
          </div>
        </div>
      </div>

      {/* Modal: View Details */}
      {selectedRecord && (
        <div className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-xs flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-lg rounded-2xl shadow-xl border border-slate-200 overflow-hidden animate-in fade-in zoom-in-95 duration-150">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50/50">
              <div className="flex items-center gap-2">
                <User className="w-5 h-5 text-sky-600" />
                <h3 className="font-bold text-slate-800">
                  รายละเอียดประวัติผู้อยู่อาศัย
                </h3>
              </div>
              <button
                type="button"
                onClick={() => setSelectedRecord(null)}
                className="w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-6 space-y-4 text-xs text-slate-700">
              <div className="flex items-center justify-between pb-3 border-b border-slate-100">
                <div>
                  <span className="text-slate-400 block mb-0.5">ชื่อ-นามสกุล</span>
                  <span className="text-base font-bold text-slate-900">{selectedRecord.fullName}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  {getTypeBadge(selectedRecord.type)}
                  <span className="px-2.5 py-0.5 rounded-full text-[11px] font-medium bg-rose-500 text-white">
                    {selectedRecord.status}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-slate-400 block mb-1">ห้องชุด / บ้านเลขที่</span>
                  <span className="font-bold text-slate-800 text-sm flex items-center gap-1.5">
                    <Home className="w-4 h-4 text-slate-400" /> {selectedRecord.roomNumber}
                  </span>
                </div>
                <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-slate-400 block mb-1">สัญชาติ</span>
                  <span className="font-bold text-slate-800 text-sm">{selectedRecord.nationality}</span>
                </div>
                <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-slate-400 block mb-1">วันที่เข้า</span>
                  <span className="font-medium text-slate-800 flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5 text-slate-400" /> {selectedRecord.moveInDate}
                  </span>
                </div>
                <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-slate-400 block mb-1">วันที่ออก</span>
                  <span className="font-medium text-slate-800 flex items-center gap-1">
                    <Calendar className="w-3.5 h-3.5 text-slate-400" /> {selectedRecord.moveOutDate}
                  </span>
                </div>
              </div>

              <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-100 space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-slate-500 flex items-center gap-1.5">
                    <Phone className="w-3.5 h-3.5 text-slate-400" /> เบอร์โทรศัพท์:
                  </span>
                  <span className="font-medium text-slate-800 font-mono">{selectedRecord.phone}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-500 flex items-center gap-1.5">
                    <Mail className="w-3.5 h-3.5 text-slate-400" /> อีเมล:
                  </span>
                  <span className="font-medium text-slate-800">{selectedRecord.email}</span>
                </div>
                <div className="flex items-start justify-between pt-1 border-t border-slate-200/60">
                  <span className="text-slate-500">สาเหตุที่ออก:</span>
                  <span className="font-medium text-slate-800">{selectedRecord.reasonForLeaving}</span>
                </div>
              </div>
            </div>

            <div className="px-6 py-3 bg-slate-50 border-t border-slate-100 flex justify-end">
              <button
                type="button"
                onClick={() => setSelectedRecord(null)}
                className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-xl font-medium text-xs transition-colors cursor-pointer"
              >
                ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
